import type { User, AuthorizedUser } from '@/types'
import HttpService from '@/services/http.service'
import { useEnvironmentStore } from '@/stores/environmentStore'
const path = 'auth'

async function init(): Promise<User> {
  const httpService = HttpService
  return await httpService.get<User>(path + '/init').then((user: User) => {
    return user
  })
}

async function confirm(token: string, tempUser: User): Promise<AuthorizedUser> {
  const env = useEnvironmentStore()
  const httpService = HttpService
  if (token) {
    env.setToken(token)
  }

  let payload = { username: 0, token: '', password: '', campaignCode: ''}

  if (tempUser && tempUser.password) {
    payload.username = tempUser.username
    payload.token = tempUser.token
    payload.password = tempUser.password
  }

  if (tempUser.campaignCode && tempUser.campaignCode != '') {
    payload.campaignCode = tempUser.campaignCode
  }

  return await httpService
    .post<AuthorizedUser>(path + '/confirm', payload)
    .then((user: AuthorizedUser) => {
      return login(user.username, payload.password)
    })
}

async function login(username: string, password: string): Promise<AuthorizedUser> {
  const env = useEnvironmentStore()
  const httpService = HttpService

  let payload = { username: username, password: password }

  return await httpService
    .post<AuthorizedUser>(path + '/login', payload)
    .then((user: AuthorizedUser) => {
      //env.setToken(user.token)

      return user
    })
}

async function changePassword(
  oldPassword: string,
  newPassword: string,
  newPasswordConfirm: string
): Promise<boolean> {
  let payload = {
    oldPassword: oldPassword,
    newPassword: newPassword,
    newPasswordConfirm: newPasswordConfirm
  }
  const env = useEnvironmentStore()
  const httpService = HttpService
  return await httpService.post<Boolean>(path + '/change-password', payload).then((result: any) => {
    return result
  })
}

export default { init, confirm, login, changePassword }
